function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M181.285,256.98c-15.915,0.274-25.088,15.952-25.088,36.698c0,20.903,9.471,35.807,25.239,36.08 c16.158,0.29,25.537-15.445,25.537-36.713C206.967,273.412,197.749,256.701,181.285,256.98z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.262,259.221c-4.736,0.076-7.781,0.577-9.574,1.062v66.564c1.793,0.484,4.704,0.543,7.338,0.585 c19.388,0.485,32.234-10.99,32.234-35.78C98.405,270.103,86.688,258.902,68.262,259.221z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.031,537.78c0.781,0.042,1.551,0.111,2.342,0.111h178.2c20.846,0,37.8-16.96,37.8-37.801V86.994 c0-20.838-16.954-37.8-37.8-37.8h-178.2c-0.786,0-1.561,0.077-2.342,0.113V0L11.228,46.417v494.564L359.031,588.6V537.78z  M361.373,70.798h178.2c8.933,0,16.2,7.27,16.2,16.2v413.103c0,8.928-7.268,16.2-16.2,16.2h-178.2 c-0.796,0-1.571-0.127-2.342-0.242V383.991h160.145c3.955,0,7.161-3.201,7.161-7.15c0-3.955-3.206-7.151-7.161-7.151H359.031 v-43.886h160.145c3.955,0,7.161-3.206,7.161-7.15c0-3.955-3.206-7.15-7.161-7.15H359.031V268.98h160.145 c3.955,0,7.161-3.199,7.161-7.151c0-3.952-3.206-7.148-7.161-7.148H359.031v-42.926h75.252c3.945,0,7.151-3.201,7.151-7.151 c0-3.952-3.206-7.153-7.151-7.153h-75.252V71.036C359.802,70.922,360.571,70.798,361.373,70.798z M105.464,333.06 c-10.223,8.87-25.574,12.762-44.01,12.276c-10.887-0.295-18.512-1.239-23.67-2.12V244.35c7.604-1.54,17.595-2.544,28.242-2.813 c17.961-0.472,29.787,2.764,39.15,10.102c10.18,7.868,16.611,20.692,16.611,39.227C121.788,310.954,114.903,324.707,105.464,333.06 z M180.178,349.123c-30.649-0.817-48.157-24.928-48.157-54.986c0-31.622,19.322-55.764,49.884-56.576 c32.74-0.862,51.057,24.113,51.057,54.662C232.962,328.525,211.283,349.951,180.178,349.123z M308.27,330.961 c8.068,0.137,17.107-1.424,22.465-3.392l4.103,20.53c-5.01,2.277-16.189,4.556-30.586,4.166 c-39.92-1.055-59.927-25.534-59.927-57.244c0-37.966,27.433-59.827,62.543-60.75c13.9-0.367,24.574,2.102,29.415,4.39 l-5.548,20.909c-5.526-2.144-13.152-4.076-22.645-3.921c-20.975,0.351-37.009,12.825-37.009,37.9 C271.081,316.122,284.705,330.555,308.27,330.961z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M477.394,226.081l6.629-26.935c1.693-6.544,2.806-12.062,3.829-18.183h0.163c0.675,6.199,1.692,11.639,3.138,18.183 l5.959,26.935h11.222l15.367-57.268h-10.621l-5.948,25.917c-1.529,6.963-2.89,13.505-3.907,19.796h-0.18 c-0.839-6.204-2.035-12.577-3.476-19.377l-5.695-26.336h-10.958l-6.196,25.917c-1.624,7.219-3.254,14.017-4.171,20.049h-0.158 c-0.938-5.693-2.3-13.004-3.75-19.965l-5.437-25.995h-11.127l14.022,57.267h11.295V226.081z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgDocExt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "588.601px",
    height: "588.6px",
    viewBox: "0 0 588.601 588.6",
    style: {
      enableBackground: "new 0 0 588.601 588.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocExt);
export default __webpack_public_path__ + "static/media/doc_ext.bafa83f6.svg";
export { ForwardRef as ReactComponent };